module.exports = __webpack_public_path__ + "img/10pts1234.a198bcb3.png";